import { render } from "./designation-model.vue?vue&type=template&id=59ad674d"
import script from "./designation-model.vue?vue&type=script&lang=js"
export * from "./designation-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__